import Button from "components/button";
import Input from "components/input";
import { UseFormReturn, Controller } from "react-hook-form";
import FleetAccordion from "./fleet-accordion";
import Typography from "components/typography";
import DatePicker from "components/date-picker";

interface FleetComplianceAccordionProps {
  isOpen: boolean;
  onToggle: () => void;
  form: any;
  t: any;
}

const FleetComplianceAccordion = ({
  isOpen,
  onToggle,
  form,
  t,
}: FleetComplianceAccordionProps) => {
  const {
    register,
    control,
    formState: { errors },
  } = form;

  return (
    <FleetAccordion
      title={t("accordion-fleet-compliance")}
      subtitle={t("accordion-fleet-compliance-subtitle")}
      iconName="wrench"
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <div className="grid grid-cols-2 gap-4">
        <Controller
          name="odometer"
          control={control}
          render={({ field, fieldState }) => (
            <Input
              label={t("label-odometer")}
              type="number"
              required
              min={0}
              data-testid="input-odometer"
              placeholder="0"
              rightIcon={<Typography variant="body" tone="muted" className="pr-3">Km</Typography>}
              value={field.value ?? ""}
              onChange={(e) => {
                const val = e.target.value === "" ? "" : Number(e.target.value);
                field.onChange(val);
              }}
              onBlur={field.onBlur}
              error={fieldState.error}
            />
          )}
        />

        <Controller
          name="lastMaintenanceDate"
          control={control}
          render={({ field, fieldState }) => (
            <DatePicker
              label={t("label-last-maintenance")}
              value={field.value}
              onChange={field.onChange}
              error={fieldState.error}
              placeholder="dd / mm / yyyy"
            />
          )}
        />
      </div>
    </FleetAccordion>
  );
};

export default FleetComplianceAccordion;
